import {createAction} from 'Shared/utilities/actionCreator';
import {FieldSalesLeader} from 'Users/models/User/Agent/FieldSalesLeader';
import * as FVP from 'Users/models/User/Agent/FieldVicePresidentUserType';

export enum FieldVicePresidentUserTypeActionType {
  ADD_FIELD_SALES_LEADER = 'fieldVicePresidentUserType/ADD_FIELD_SALES_LEADER',
  REMOVE_FIELD_SALES_LEADER = 'fieldVicePresidentUserType/REMOVE_FIELD_SALES_LEADER',
  LOAD_FIELD_SALES_LEADERS = 'fieldVicePresidentUserType/LOAD_FIELD_SALES_LEADERS',
}

export const addFieldSalesLeader = (fieldSalesLeader: FieldSalesLeader) =>
  createAction(FieldVicePresidentUserTypeActionType.ADD_FIELD_SALES_LEADER, {fieldSalesLeader});
export const removeFieldSalesLeader = (fieldSalesLeader: FieldSalesLeader) =>
  createAction(FieldVicePresidentUserTypeActionType.REMOVE_FIELD_SALES_LEADER, {fieldSalesLeader});
export const loadFieldSalesLeaders = (fieldSalesLeaders: FieldSalesLeader[]) =>
  createAction(FieldVicePresidentUserTypeActionType.LOAD_FIELD_SALES_LEADERS, {fieldSalesLeaders});

type FieldVicePresidentUserTypeState = FVP.FieldVicePresidentUserType;

export const DEFAULT_STATE: FieldVicePresidentUserTypeState = FVP.EmptyFieldVicePresidentUserType;

export type FieldVicePresidentUserTypeAction =
  | ReturnType<typeof loadFieldSalesLeaders>
  | ReturnType<typeof addFieldSalesLeader>
  | ReturnType<typeof removeFieldSalesLeader>;

export default (
  state: FieldVicePresidentUserTypeState = DEFAULT_STATE,
  action: FieldVicePresidentUserTypeAction
): FieldVicePresidentUserTypeState => {
  switch (action.type) {
    case FieldVicePresidentUserTypeActionType.ADD_FIELD_SALES_LEADER: {
      const {fieldSalesLeader} = action.payload;

      return FVP.addFieldSalesLeader(fieldSalesLeader)(state);
    }
    case FieldVicePresidentUserTypeActionType.LOAD_FIELD_SALES_LEADERS: {
      const {fieldSalesLeaders} = action.payload;

      return FVP.loadFieldSalesLeaders(fieldSalesLeaders);
    }
    case FieldVicePresidentUserTypeActionType.REMOVE_FIELD_SALES_LEADER: {
      const {fieldSalesLeader} = action.payload;

      return FVP.removeFieldSalesLeader(fieldSalesLeader)(state);
    }
    default:
      return state;
  }
};
